import React from "react";
import Modal from "react-bootstrap/Modal";

interface LoaderExportFileKirkosModalProps {
  show: boolean;
}

const LoaderExportFileKirkosModal: React.FC<
  LoaderExportFileKirkosModalProps
> = ({ show }) => {
  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Body className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Fetching orders, please wait...</p>
      </Modal.Body>
    </Modal>
  );
};

export default LoaderExportFileKirkosModal;
